

























































































import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "poster-modal-component",
})
export default class PosterModalComponent extends Vue {
  get active() {
    return this.$store.getters["SystemStore/getOpenPosterModal"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setOpenPosterModalAction", e);
  }
  get poster() {
    return this.$store.getters["SystemStore/getPoster"];
  }
  openWeb(): void {
    if (this.poster.openUrlExternally) {
      window.open(this.poster.url, "_blank").focus();
    } else {
      this.$store.dispatch(
        "SystemStore/setWonderPointUrlAction",
        this.poster.url
      );
      this.$store.dispatch("SystemStore/setOpenWonderPointModalAction", true);
      this.active = false;
    }
  }
  convertToEmbed(url: string): string {
    if (url.includes("twitch"))
      return `${url}&parent=${window.location.hostname}`;
    const replace = url
      .replace(
        /(?:http:|https:)?(?:\/\/)(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([^<.,!():"'\s]+)/g,
        "https://www.youtube.com/embed/$1"
      )
      .replace(
        /(?:http:|https:)?(?:\/\/)(?:www\.)?(?:vimeo\.com)\/([^<.,!():"'\s]+)/g,
        "//player.vimeo.com/video/$1"
      )
      .replace(
        /(?:http:|https:)?(?:\/\/)(?:dailymotion\.com|dai\.ly)\/([^<.,!():"'\s]+)/g,
        "https://www.dailymotion.com/embed/video/$1"
      )
      .split("&")[0];
    return replace;
  }
}
